import { create } from 'zustand';

const useAssessmentStore = create((set, get) => ({
  // User data from email gate
  userData: null,
  
  // Answers: index -> selected option index
  answers: {},
  
  // Current question index (0-based)
  currentQuestion: 0,
  
  // Assessment state
  isComplete: false,
  results: null,
  
  // Actions
  setUserData: (data) => set({ userData: data }),
  
  setAnswer: (questionIndex, optionIndex) => set((state) => ({
    answers: { ...state.answers, [questionIndex]: optionIndex }
  })),
  
  nextQuestion: () => set((state) => ({
    currentQuestion: Math.min(state.currentQuestion + 1, 19)
  })),
  
  previousQuestion: () => set((state) => ({
    currentQuestion: Math.max(state.currentQuestion - 1, 0)
  })),
  
  goToQuestion: (index) => set({ currentQuestion: index }),
  
  completeAssessment: (results) => set({
    isComplete: true,
    results
  }),
  
  resetAssessment: () => set({
    userData: null,
    answers: {},
    currentQuestion: 0,
    isComplete: false,
    results: null
  }),
  
  // Getters
  getProgress: () => {
    const state = get();
    return {
      current: state.currentQuestion + 1,
      total: 20,
      percentage: ((state.currentQuestion + 1) / 20) * 100
    };
  },
  
  getAnswerCount: () => Object.keys(get().answers).length,
  
  getIndustry: () => get().userData?.industry || 'other',
  
  getCompanySize: () => get().userData?.companySize || '201-500'
}));

export default useAssessmentStore;
